module.exports = "<h1>\r\nMeter Log History\r\n</h1>\r\n<div class=\"flex-item\">\r\n{{data}}\r\n</div>"